import * as React from "react";
import { Text } from "@fluentui/react-components";

const LoginHeader = ({ title, message }) => {
  return (
    <div>
      <Text as="h1" size={400} weight="semibold" block>
        {title}
      </Text>
      <Text as="p" size={200} block>
        {message}
      </Text>
    </div>
  );
};

export default LoginHeader;
